// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3gtaC","footer":"ModalError_footer__3NCbX"};